import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface ArConnectApiKeyCreatedNotifyAuthorProps extends BaseTemplateProps {}

export const ArConnectApiKeyCreatedNotifyAuthor: TemplateDefinition<ArConnectApiKeyCreatedNotifyAuthorProps> =
  {
    renderParams: (props: ArConnectApiKeyCreatedNotifyAuthorProps) => ({
      messageKey: 'notificationsDomain.templates.arConnectApiKeyCreatedNotifyAuthor',
      values: {},
    }),
  }
